import React from 'react';
import { FormattedMessage } from 'react-intl';

import Text from 'app/components/layout/Text.styled';
import Styled from 'app/features/migration/landing/components/HeroBlock.styled';

const PromotionRequirements = () => (
  <Styled.PromotionRequirements>
    <Text size="l" as="p">
      <FormattedMessage id="migration_landing_promotion_requirements" />
    </Text>
    <Text size="l" as="p">
      <FormattedMessage id="migration_landing_promotion_requirements_deadline" />
    </Text>
  </Styled.PromotionRequirements>
);

export default PromotionRequirements;
